export default __webpack_public_path__ + "static/media/canadalife-glyph.74022bd3.png";